export default __webpack_public_path__ + "static/media/no_contacts.51da4e4e.svg";